export const data = {
  experience: [
    {
      title: "Fresher Front End Developer",
      subTitle: "NO experience-previous",
      description:
        " 6 or more than projects have completed using HTML,CSS,JAVASCRIPT,REACT JS,NODE JS and MONGODB",
      status: "2020 - present",
    },
  ],
  education: [
    {
      title: "Higher Secondary",
      subTitle: "Bandarban Government College",
      description: "Passed with GPA 3.68 in 2019",
      status: "2017 - 2019",
    },
    {
      title: "BSc in Engineering of CSE",
      subTitle: "Bandarban University",
      description: "7th semester running. 1 semester left.",
      status:"2020 - present"
    },
  ],
};
